type ClassValue = string | number | boolean | null | undefined | ClassArray | ClassDictionary;

type ClassArray = ClassValue[];

type ClassDictionary = Record<string, boolean | null | undefined>;

const appendClassName = (target: string, value: string): string => (target ? `${target} ${value}` : value);

const resolveArray = (values: ClassArray): string => {
  let result = '';

  for (const item of values) {
    if (!item) {
      continue;
    }

    const resolved = resolveValue(item);

    if (resolved) {
      result = appendClassName(result, resolved);
    }
  }

  return result;
};

const resolveObject = (values: ClassDictionary): string => {
  let result = '';

  for (const key in values) {
    if (values[key]) {
      result = appendClassName(result, key);
    }
  }

  return result;
};

const resolveValue = (value: ClassValue): string => {
  if (typeof value === 'string' || typeof value === 'number') {
    return String(value);
  }

  if (Array.isArray(value)) {
    return resolveArray(value);
  }

  if (value && typeof value === 'object') {
    return resolveObject(value);
  }

  return '';
};

export const ClassNames = (...values: ClassValue[]): string => {
  let result = '';

  for (const value of values) {
    if (!value) {
      continue;
    }

    const resolved = resolveValue(value);

    if (resolved) {
      result = appendClassName(result, resolved);
    }
  }

  return result;
};
